import { IParameter, IParameterValue } from '@/interfaces/parameters';
import {
  OVERRIDE_WEIGHT_EMEDE,
  REFERENCE_TYPE_EMEDE,
  REFERENCE_TYPE_TEAM,
  OVERRIDE_WEIGHT_TEAM,
  REFERENCE_TYPE_DOCTOR,
  OVERRIDE_WEIGHT_DOCTOR,
  OVERRIDE_WEIGHT_CLIENT,
  REFERENCE_TYPE_CLIENT,
} from '@/settings/consts/rules-engine';
import { TypeRuleReference } from '@/interfaces/rules-engine';

export default class ParameterModel {
  public id: string;
  public nome: string;
  public tipoParametro: string;
  public valores: IParameterValue[];
  public peso: string;
  public hierarquia: TypeRuleReference;
  public referenciaHierarquia: string;
  public hierarquiasPossiveis: string[];
  public sobrescreve: IParameter;
  public unidade: any;

  constructor(_initialValues?: IParameter) {
    const initialValues = _initialValues || {
      id: '',
      nome: '',
      tipoParametro: '',
      valores: [],
      peso: OVERRIDE_WEIGHT_EMEDE,
      hierarquia: REFERENCE_TYPE_EMEDE,
      referenciaHierarquia: '',
      hierarquiasPossiveis: [],
      sobrescreve: null,
      unidade: null,
    };

    this.id = initialValues.id;
    this.nome = initialValues.nome;
    this.tipoParametro = initialValues.tipoParametro;
    this.valores = initialValues.valores;
    this.peso = initialValues.peso;
    this.hierarquia = initialValues.hierarquia;
    this.sobrescreve = initialValues.sobrescreve;
    this.referenciaHierarquia = initialValues.referenciaHierarquia;
    this.hierarquiasPossiveis = initialValues.hierarquiasPossiveis;
    this.unidade = initialValues.unidade;
  }

  public validate(): boolean {
    return !!this.nome && !!this.tipoParametro && !!this.hierarquia;
  }

  public toJson(): IParameter {
    switch (this.hierarquia) {
      case REFERENCE_TYPE_TEAM:
        this.peso = OVERRIDE_WEIGHT_TEAM;
        break;
      case REFERENCE_TYPE_DOCTOR:
        this.peso = OVERRIDE_WEIGHT_DOCTOR;
        break;
      case REFERENCE_TYPE_CLIENT:
        this.peso = OVERRIDE_WEIGHT_CLIENT;
        break;
      default:
        this.peso = OVERRIDE_WEIGHT_EMEDE;
        break;
    }

    if (!!this.unidade && !!this.unidade.id) {
      this.unidade = {
        id: this.unidade.id,
      };
    } else {
      this.hierarquia = REFERENCE_TYPE_EMEDE;
      this.peso = OVERRIDE_WEIGHT_EMEDE;
    }

    return {
      id: this.id,
      nome: this.nome,
      tipoParametro: this.tipoParametro,
      valores: this.valores,
      sobrescreve: this.sobrescreve,
      peso: this.peso,
      hierarquia: this.hierarquia,
      referenciaHierarquia: this.referenciaHierarquia,
      hierarquiasPossiveis: this.hierarquiasPossiveis,
      unidade: this.unidade,
    };
  }
}
